import { AnalyticsContext } from '@backstage/core-plugin-api';
import { stringifyEntityRef } from '@backstage/catalog-model';
import {
  useCustomEntityAnalytics,
  useEntityPageAnalytics,
  useTechDocsAnalytics,
} from '../hooks';

export const EntityPageWithAnalytics = ({
  children,
}: {
  children: JSX.Element;
}) => {
  // Catalogページアクセスイベントを送信
  useEntityPageAnalytics();

  // TechDocsタブアクセスイベントを送信（/docsパスの場合のみ）
  useTechDocsAnalytics();

  const { entity, loading, error } = useCustomEntityAnalytics();

  // エンティティがロード中またはエラーの場合は、子コンポーネントをそのまま表示
  if (loading || error || !entity) {
    return <>{children}</>;
  }

  const analyticsContext = {
    extension: 'CatalogEntityPage',
    entityRef: stringifyEntityRef(entity),
    entityKind: entity.kind,
    entityType: (entity.spec as any)?.type || 'unknown',
    entityName: entity.metadata.name,
    namespace: entity.metadata.namespace || 'default',
  };

  return (
    <AnalyticsContext attributes={analyticsContext}>
      {children}
    </AnalyticsContext>
  );
};
